import { render } from "./Argument5.vue?vue&type=template&id=4aef2cb8"
import script from "./Argument5.vue?vue&type=script&lang=js"
export * from "./Argument5.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__